var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuGameColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45044 19.9998C9.1038 19.9494 8.75502 19.9106 8.41089 19.8466C6.44096 19.4801 4.7912 18.536 3.45643 17.0495C2.27737 15.7365 1.54153 14.1996 1.30256 12.4514C0.92694 9.70364 1.67395 7.28108 3.53339 5.22056C4.61754 4.01925 5.95512 3.20249 7.50677 2.73921C7.55632 2.72443 7.60666 2.71201 7.67365 2.69394C8.02848 3.4032 8.38222 4.11031 8.74364 4.83283C6.74061 5.29434 5.23083 6.39811 4.27403 8.20848C3.56723 9.54586 3.37879 10.9742 3.67938 12.4542C4.28395 15.4311 6.902 17.5839 9.93101 17.6147C12.9562 17.6455 15.6189 15.5542 16.2811 12.603C16.6762 10.8418 16.3878 9.18287 15.4043 7.66678C14.4223 6.15308 13.0195 5.22866 11.2506 4.83513C11.6114 4.1136 11.9628 3.41093 12.3327 2.67102C12.7308 2.81883 13.1362 2.9384 13.5151 3.11504C16.4252 4.47157 18.2016 6.72517 18.6929 9.90325C19.4048 14.5084 16.2969 18.8943 11.7195 19.8263C11.3322 19.9052 10.9366 19.943 10.5448 19.9998H9.45044Z",
    fill: "#75A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5825 5.95288C11.5962 6.07083 12.4727 6.43747 13.2631 7.05733C13.2162 7.10976 13.1844 7.14897 13.1488 7.18452C12.3902 7.9437 11.6322 8.70365 10.8695 9.45859C10.8198 9.50772 10.7297 9.54281 10.663 9.53644C10.6307 9.53341 10.5861 9.41922 10.5858 9.35516C10.5811 8.2754 10.5825 7.19565 10.5825 6.11589V5.95288Z",
    fill: "#FDC251"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7832 10.5731C4.90079 9.57063 5.26476 8.69685 5.88416 7.90332C5.93298 7.94509 5.97725 7.97814 6.016 8.01683C6.77538 8.77522 7.53528 9.53314 8.29022 10.296C8.3393 10.3456 8.34906 10.434 8.3771 10.5044C8.31225 10.5299 8.24751 10.5774 8.18251 10.5776C7.10927 10.5823 6.03599 10.581 4.96271 10.5807C4.91165 10.5807 4.86058 10.5764 4.7832 10.5731Z",
    fill: "#FDC251"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90227 14.4199C5.38281 13.9259 4.80304 12.5321 4.79834 11.7535H4.98552C6.04575 11.7535 7.10603 11.752 8.16621 11.7569C8.23706 11.7572 8.30771 11.8066 8.3784 11.8331C8.34911 11.9032 8.33736 11.9908 8.28781 12.0409C7.53277 12.8036 6.77281 13.5615 6.01364 14.3201C5.97819 14.3556 5.93892 14.3873 5.90227 14.4199Z",
    fill: "#FDC251"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5916 16.379C10.588 16.3034 10.5829 16.246 10.5828 16.1887C10.5824 15.122 10.5808 14.0553 10.5863 12.9886C10.5866 12.92 10.6254 12.8271 10.6775 12.7923C10.7095 12.7709 10.8169 12.823 10.8635 12.8692C11.6349 13.634 12.402 14.403 13.1698 15.1714C13.1968 15.1984 13.2213 15.2279 13.2648 15.2761C12.4736 15.896 11.5951 16.2659 10.5916 16.379Z",
    fill: "#FDC251"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7373 7.05234C7.52436 6.43555 8.39897 6.0744 9.3931 5.9541C9.39989 6.01446 9.41002 6.0626 9.41007 6.11084C9.41101 7.19702 9.41195 8.28315 9.40767 9.36928C9.40746 9.42864 9.37655 9.51782 9.33358 9.5386C9.29102 9.55917 9.19652 9.52941 9.15647 9.48978C8.36195 8.70231 7.57198 7.91025 6.78148 7.1187C6.76853 7.1057 6.76054 7.08769 6.7373 7.05234Z",
    fill: "#FDC251"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2113 10.5811H14.4837C13.5862 10.5811 12.6887 10.5825 11.7911 10.5778C11.7327 10.5775 11.6437 10.5431 11.6249 10.5001C11.6057 10.456 11.6375 10.3642 11.6776 10.3236C12.4605 9.53363 13.2478 8.74809 14.0346 7.96203C14.0519 7.94469 14.0736 7.93169 14.1092 7.90454C14.7274 8.68982 15.0909 9.56736 15.2113 10.5811Z",
    fill: "#FDC251"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2115 11.7535C15.0915 12.7669 14.7274 13.6442 14.1067 14.4334C14.0497 14.3814 14.006 14.3446 13.9658 14.3044C13.2159 13.5551 12.4652 12.8065 11.7196 12.0529C11.6656 11.9984 11.6499 11.906 11.6165 11.8313C11.6876 11.8054 11.7586 11.7572 11.83 11.7568C12.89 11.752 13.9502 11.7535 15.0103 11.7535H15.2115Z",
    fill: "#FDC251"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41067 16.38C8.40395 16.2658 7.52814 15.8981 6.73096 15.2786C6.78176 15.2226 6.82165 15.1746 6.86556 15.1306C7.61476 14.3806 8.36318 13.6298 9.11697 12.8845C9.17054 12.8315 9.26478 12.8197 9.34007 12.7888C9.36362 12.8616 9.40732 12.9343 9.40764 13.0072C9.41207 14.0608 9.41067 15.1144 9.41067 16.168V16.38Z",
    fill: "#FDC251"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3355 0C11.556 1.5717 10.7868 3.12284 9.99591 4.71746C9.20709 3.12707 8.43632 1.57322 7.65601 0H12.3355Z",
    fill: "#FDC251"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_401_152)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5826 11.16C10.5866 11.4761 10.3252 11.7462 10.0089 11.7528C9.68585 11.7595 9.41017 11.488 9.41163 11.1643C9.41309 10.8481 9.6787 10.5828 9.99495 10.5815C10.311 10.5802 10.5786 10.8437 10.5826 11.16Z",
    fill: "#FDC251"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_401_152",
    x: 4.41162,
    y: 3.58154,
    width: 11.1711,
    height: 11.1714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.0941176 0 0 0 0 0.243137 0 0 0 0.513512 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_401_152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_401_152",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGameColor);
export default __webpack_public_path__ + "static/media/menu-game-color.9667010008bcbd5008fcdb3d81cf11f6.svg";
export { ForwardRef as ReactComponent };